import { render, staticRenderFns } from "./FundSelector.vue?vue&type=template&id=2bfdcac0&"
import script from "./FundSelector.vue?vue&type=script&lang=js&"
export * from "./FundSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports